import axios from "axios"

export function getTemplateData() {
    const url = new URLSearchParams(window.location.search);
    const token = url.get("token");
    
    return axios.get(`${process.env.REACT_APP_URL}/v4/customer/redemption/template?token=${token}`)
}
